import util from '@/utils/util';
// console.log('8888888888888888',util);

export const publicData = {
  // logo:require("@/assets/img/logo.png"),
  projectName: '支付页面',
  getComArgs:
    process.env.NODE_ENV === 'development' || util.getUrlQueryString('testId')
      ? // process.env.NODE_ENV === "development"
        'token=125&udid=125&productId=9a8f2754-aa0d-449e-b8f2-30cbdd53cf43&vestId=51774ff9-0257-4089-8c83-8bf81f8f7141&channel=test&osType=android&version=1'
      : '',
  payList: [
    {
      payMode: 'alipay',
      supportFlag: true,
      defaultPayFlag: false,
    },
    {
      payMode: 'weChat',
      supportFlag: true,
      defaultPayFlag: true,
    },
  ],
};
